var cov_q4qjhy81w = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Checkbox/context.tsx",
      hash = "393239cd2f516762785ea407e7005f18632e5852",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Checkbox/context.tsx",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 16
        },
        end: {
          line: 5,
          column: 90
        }
      },
      "1": {
        start: {
          line: 7,
          column: 28
        },
        end: {
          line: 7,
          column: 35
        }
      },
      "2": {
        start: {
          line: 9,
          column: 25
        },
        end: {
          line: 13,
          column: 1
        }
      },
      "3": {
        start: {
          line: 11,
          column: 41
        },
        end: {
          line: 13,
          column: 1
        }
      },
      "4": {
        start: {
          line: 12,
          column: 2
        },
        end: {
          line: 12,
          column: 87
        }
      },
      "5": {
        start: {
          line: 12,
          column: 30
        },
        end: {
          line: 12,
          column: 67
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 9,
            column: 25
          },
          end: {
            line: 9,
            column: 26
          }
        },
        loc: {
          start: {
            line: 11,
            column: 41
          },
          end: {
            line: 13,
            column: 1
          }
        },
        line: 11
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 11,
            column: 41
          },
          end: {
            line: 11,
            column: 42
          }
        },
        loc: {
          start: {
            line: 12,
            column: 2
          },
          end: {
            line: 12,
            column: 87
          }
        },
        line: 12
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 12,
            column: 21
          },
          end: {
            line: 12,
            column: 22
          }
        },
        loc: {
          start: {
            line: 12,
            column: 30
          },
          end: {
            line: 12,
            column: 67
          }
        },
        line: 12
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

var _this = this,
    _jsxFileName = "/Users/spana/SHEIN/shineout/src/Checkbox/context.tsx";

import React from 'react';
import createReactContext from '../context';
var context = (cov_q4qjhy81w.s[0]++, createReactContext({}));

var _ref = (cov_q4qjhy81w.s[1]++, context),
    Provider = _ref.Provider;

export { Provider };
cov_q4qjhy81w.s[2]++;
export var consumer = function consumer(Origin) {
  cov_q4qjhy81w.f[0]++;
  cov_q4qjhy81w.s[3]++;
  return function (props) {
    cov_q4qjhy81w.f[1]++;
    cov_q4qjhy81w.s[4]++;
    return (
      /*#__PURE__*/
      React.createElement(context.Consumer, {
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 12,
          columnNumber: 3
        }
      }, function (value) {
        cov_q4qjhy81w.f[2]++;
        cov_q4qjhy81w.s[5]++;
        return (
          /*#__PURE__*/
          React.createElement(Origin, Object.assign({}, props, value, {
            __self: _this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 12,
              columnNumber: 31
            }
          }))
        );
      })
    );
  };
};